// Bug Intake #524: a distributor acknowledges the "fixed prices below cost or
// under the margin floor" warning once and is not nagged again until the
// flagged set changes.
//
// Persistence is localStorage, per USER and per STORE, keyed the way the
// repo's other per-user preferences are (StoreProducts/viewModePreference.js:
// the "userId" key, a safeStorage() guard, best-effort writes). What is stored
// is the server's `signature` of the flagged set, so editing a flagged price or
// a new product falling under the floor brings the warning back, while an
// unchanged list stays quiet. No schema, no new endpoint.

export const ACK_STORAGE_KEY_PREFIX = "tf:fixed-price-margin-ack:";

function safeStorage() {
  try {
    if (typeof window === "undefined" || !window.localStorage) return null;
    return window.localStorage;
  } catch {
    return null;
  }
}

function currentUserId() {
  const store = safeStorage();
  if (!store) return null;
  try {
    return store.getItem("userId");
  } catch {
    return null;
  }
}

function keyFor(userId, storeId) {
  return `${ACK_STORAGE_KEY_PREFIX}${userId}:${storeId}`;
}

/** True when this user already acknowledged exactly this flagged set. */
export function isMarginWarningAcknowledged(storeId, signature) {
  if (!signature) return false;
  const userId = currentUserId();
  const store = safeStorage();
  if (userId == null || userId === "" || storeId == null || !store) return false;
  try {
    return store.getItem(keyFor(userId, storeId)) === signature;
  } catch {
    return false;
  }
}

/** Remember that this user has seen this flagged set. Best effort. */
export function acknowledgeMarginWarning(storeId, signature) {
  if (!signature) return;
  const userId = currentUserId();
  const store = safeStorage();
  if (userId == null || userId === "" || storeId == null || !store) return;
  try {
    store.setItem(keyFor(userId, storeId), signature);
  } catch {
    // Quota / private mode: the warning simply shows again next visit.
  }
}
